<template>

  <div>
    <v-icon class="mr-1 icon-download" color="primary">mdi-download</v-icon>
    <a :href="downloadPageUri" class="download-link" title="Download Invoice" target="_new">Download Invoice</a>
  </div>

</template>

<script>
export default {
  name: 'OrderInvoiceDownload',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    downloadPageUri () {
      const host = (window) ? `${window.location.protocol}//${window.location.host}` : 'localhost'
      return `${host}/download/order/${this.order.id}?order_number=${encodeURIComponent(this.order.order_number)}`
    }
  }
}
</script>

<style scoped>
  a.download-link {
    text-decoration: none;
  }

  a.download-link:hover {
    text-decoration: underline;
  }
</style>
